import { k } from "../kaplay";

export function addCard(card_data, offset){
  const cardWidth = 250;
  const cardHeight = 400;
  
  const newCard = k.add([
    "card",

    k.sprite("card"),
    k.pos(k.center().add(offset)),
    k.anchor("center"),
    k.layer("ui"),
    k.scale(),
    k.area(),

    { card_data: card_data }
  ])

  newCard.onHover(() => {
    newCard.scaleTo(1.05);
  })
  newCard.onHoverEnd(() => {
    newCard.scaleTo(1);
  })

  const marginX = 20;
  newCard.add([
    k.text(card_data.title, { font: "happy", size: 30, width: cardWidth - marginX * 2, align: "center" }),
    k.pos(-cardWidth / 2 + marginX, 30),
  ])

  newCard.add([
    k.text(card_data.description, { font: "happy", size: 24, width: cardWidth - marginX * 2 }),
    k.pos(-cardWidth / 2 + marginX, cardHeight/5 + 15),
  ])

  newCard.add([
    k.sprite(card_data.icon.name),
    k.anchor("center"),
    k.pos(0, -cardHeight/4),
    k.scale(card_data.icon.scale),
    k.rotate(card_data.icon.angle),
  ])

  return newCard;
}